import { LoadingOverlay } from "@mantine/core";

export const LoadScreen = () => (
  <div className="d-flex justify-content-center" style={{ height: "80vh" }}>
    <LoadingOverlay visible/>
  </div>
);
